export default __webpack_public_path__ + "static/media/redline.9acf62bf.png";